import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '@df/design-system-components';

/**
 * Builds df-select options from a list of objects.
 * @example containerModels | selectOptions:'containermodelName'
 * @example devices | selectOptions:'mobileDevicepk':'mobileDeviceId'
 */
@Pipe({
    name: 'selectOptions',
    standalone: false
})
export class SelectOptionsPipe implements PipeTransform {

    transform<T>(items: T[] | null | undefined, valueField: keyof T, labelField: keyof T = valueField): SelectOption<any>[] {
        return (items ?? []).map(item => ({
            value: item[valueField],
            label: `${item[labelField] ?? ''}`
        }));
    }
}
